import CardMain from "./Pantalla_Base/Card_Main";

/*
  Cada tarjeta es una ruta. Para mostrar el diseño CON FOTO:
  1. Guarda la foto en la carpeta public/static/FotosPerfiles/ (ej. public/static/FotosPerfiles/GustavoRios.jpg).
     Usa fotos ligeras (unos 680 px de ancho), no la original de varios MB.
  2. Agrega foto={"/static/FotosPerfiles/GustavoRios.jpg"} a su CardMain.
  Si no tiene "foto", se muestra el diseño SIN FOTO (logo gris).
  Si no tiene celular, usa celular={"VACIO"} y se ocultan teléfono y WhatsApp.
  Si tiene LinkedIn propios, agrega linkedin={[{ nombre: "Personal", url: "..." }]}.
  Se mostrará un menú con esos LinkedIn + el de TrafficLight.
*/
export const rutasPortalMkt = [
    // { ruta: "/OswaldoH", component: <CardMain nombre={"Oswaldo Hdz"} puestoKey="OswaldoH" lang={lang}
    //     celular={"+52 222 675 4278"} correo={"ohernandez@trafficlight.mx"} /> },
    
    /* Tarjeta de José Miguel */
    { ruta: '/JoseMiguelRivas', component: <CardMain nombre={"José Miguel Rivas"} puesto="JoseMiguelRivas"
    celular={"+52 222 509 2268"} correo={"jrivas@trafficlight.mx"}/> },
    /* Tarjeta de Gustavo Rios */
    { ruta: '/GustavoRios', component: <CardMain nombre={"Gustavo Ríos"} puesto="GustavoRios" 
    celular={"+52 222 158 2334"} correo={"grios@trafficlight.mx"}/> },
    /* Tarjeta de Sergio Rios */
    { ruta: '/SergioRios', component: <CardMain nombre={"Sergio Ríos"} puesto="SergioRios"
    celular={"VACIO"} correo={"srios@trafficlight.mx"}/> },
    /* Tarjeta de Janine Safawi */
    { ruta: '/JanineSafawi', component: <CardMain nombre={"Janine Safawi"} puesto="JanineSafawi"
    celular={"+52 222 662 4577"} correo={"jsafawi@trafficlight.mx"}/> },
    /* Tarjeta de Jesús Castillo */
    { ruta: '/JesusCastillo', component: <CardMain nombre={"Jesús Castillo"} puesto="JesusCastillo"
    celular={"+52 222 590 0844"} correo={"jcastillo@trafficlight.mx"}/> },
    /* Tarjeta de Monserrat Montero */
    { ruta: '/MontserratMontero', component: <CardMain nombre={"Montserrat Montero"} puesto="MontserratMontero"
    celular={"+52 222 429 2743"} correo={"mmontero@trafficlight.mx"}/> },
    /* Tarjeta de Adriana Meraz */
    { ruta: '/AdrianaMeraz', component: <CardMain nombre={"Adriana Meraz"} puesto="AdrianaMeraz"
    celular={"+52 221 147 9781"} correo={"lmeraz@trafficlight.mx"}/> },
    /* Tarjeta de Ariel Ruiz */
    { ruta: '/ArielRuiz', component: <CardMain nombre={"Ariel Ruíz"} puesto="ArielRuiz"
    celular={"+52 221 110 0690"} correo={"afruiz@trafficlight.mx"} vacantes={true}
    linkedin={[
        { nombre: "Personal", url: "https://www.linkedin.com/in/ariel-fernando-ruiz-fuentes-b19b0a1ba/" },
        { nombre: "Gestión de Talento", url: "https://www.linkedin.com/in/gesti%C3%B3n-de-talento-trafficlight-280226153/" },
    ]}/>},
     /* Tarjeta de Lucero Jimenez */
    { ruta: '/LuceroJimenez', component:<CardMain nombre={"Lucero Jímenez"} puesto="LuceroJimenez"
     celular={"+52 222 324 6578"} correo={"ljimenez@trafficlight.mx"} vacantes={true} foto={"/static/FotosPerfiles/LuceroJimenez.webp"}
     linkedin={[
        { nombre: "Personal", url: "https://www.linkedin.com/in/lucero-jimenez-8b4a05167/" },
        { nombre: "Gestión de Talento", url: "https://www.linkedin.com/in/gesti%C3%B3n-de-talento-trafficlight-280226153/" },
     ]}/>},
    /* Tarjeta de Adrián Lima */
    { ruta: '/AdrianLima', component: <CardMain nombre={"Adrián Lima"} puesto="AdrianLima"
    celular={"+52 221 120 2046"} correo={"adlima@trafficlight.mx"} vacantes={true}
    linkedin={[
        { nombre: "Personal", url: "https://www.linkedin.com/in/adrian-lima-968127269/" },
        { nombre: "Gestión de Talento", url: "https://www.linkedin.com/in/gesti%C3%B3n-de-talento-trafficlight-280226153/" },
    ]}/>},
    /* Tarjeta de Selene Gutiérrez */
    { ruta: '/SeleneGutierrez', component: <CardMain nombre={"Selene Gutiérrez"} puesto="SeleneGutierrez"
    celular={"+52 223 206 8001"} correo={"segutierrez@trafficlight.mx"} vacantes={true}
    linkedin={[
        { nombre: "Personal", url: "https://www.linkedin.com/in/selene-guti%C3%A9rrez-8b0a90242/" },
        { nombre: "Gestión de Talento", url: "https://www.linkedin.com/in/gesti%C3%B3n-de-talento-trafficlight-280226153/" },
    ]}/>}

];